import React from 'react'
import CashBackTable from './components/CashbackTable'

export default function Cashback() {

  return (
    <section className="w-full bg-white rounded-xl mb-5 shadow-sm">
      <CashBackTable />
    </section>
  )
}